export const setCookie = (
  name: string,
  value: any,
  domain?: string,
  days: number = 365,
) => {
  if (typeof document === "undefined") {
    return;
  }

  const date = new Date();

  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

  const expires = `expires=${date.toUTCString()}`;

  document.cookie = `${name}=${JSON.stringify(value)};${expires};path=/;domain=${domain}`;
};

export const getCookie = (name: string): Object | null => {
  if (typeof document === "undefined") {
    return null;
  }

  let cookieName = name + "=";
  let ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }

    if (c.indexOf(cookieName) == 0) {
      let cookieValue = "";

      try {
        cookieValue = JSON.parse(c.substring(cookieName.length, c.length));
      } catch (e) {
        cookieValue = c.substring(cookieName.length, c.length);
      }

      return cookieValue;
    }
  }

  return null;
};

export const deleteCookie = (name: string) => {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
};
